"use client";

import { getYear } from "date-fns";
import Link from "next/link";
import Logo from "public/next-public/common/net32-logo.svg";
import styles from "./unknown.module.scss";

interface FallbackProps {
  error?: Error;
}

const UnknownError: React.FC<FallbackProps> = () => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <header className={styles.header}>
          <Link className={styles.logo} href="/" aria-label="Net32 home">
            <Logo width={123} height={34} />
          </Link>
          <span className={styles.needHelp}>
            Need help? Call <strong>(800) 517-1997</strong>
          </span>
        </header>

        <section className={styles.main}>
          <h1 className={styles.oops}>
            O<span className={styles.oopsAccent}>o</span>ps!
          </h1>
          <p className={styles.heading}>Something Went Wrong</p>
          <p className={styles.text}>We&apos;re having trouble loading this page. Please try again shortly.</p>
        </section>

        <footer className={styles.footer}>
          <p className={styles.footerText}>
            Copyright © {getYear(new Date())} Net32 Inc. All rights reserved. Net32&apos;s proprietary comparison
            shopping software is protected by U.S. Patent #7107226.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default UnknownError;
